/* eslint-disable import/prefer-default-export */
export function cssVars(vals) {
  const cssCase = (name) => name.replace(/([A-Z])/g, (_, m) => `-${m.toLowerCase()}`);
  return Object.entries(vals).reduce((vars, [name, val]) => ({
    ...vars,
    [`--${cssCase(name)}`]: val,
  }), {});
}

export function getRootCSSVariable(varName) {
  const name = varName.replace(/var\((.*?)\)/, '$1');
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
